'use client';
import { useTranslations } from 'next-intl';
import { InputProps } from 'supertokens-auth-react/lib/build/recipe/emailpassword/components/library/input';

import { Input, Typography } from '@/components/atoms';
import { Link } from '@/i18n/routing';

export const NewsletterConsent = ({ value, name, onChange }: InputProps) => {
  const t = useTranslations();
  return (
    <div data-supertokens="conditionContainer">
      <Input
        name={name}
        type="checkbox"
        checked={value === 'J'}
        onChange={e => onChange(e.target.checked ? 'J' : 'N')}
        data-supertokens="conditionCheckbox"
      />
      <Typography.Text data-supertokens="conditionText">
        {t('AUTH_SIGNUP_BSO_NEWSLETTER_PREFIX')}
        <a
          href="https://supertokens.com/legal/terms-and-conditions"
          data-supertokens="link"
        >
          {t('AUTH_SIGNUP_BSO_NEWSLETTER_LINK')}
        </a>{' '}
        {t('AUTH_SIGNUP_BSO_NEWSLETTER_SUFFIX')}
      </Typography.Text>
    </div>
  );
};

export const TermsAgreement = ({
  value,
  name,
  onChange,
  hasError,
}: InputProps) => {
  const t = useTranslations();
  const inputId = `terms-checkbox-${name}`;

  return (
    <label htmlFor={inputId} data-supertokens="infoConditionContainer">
      <Input
        id={inputId}
        name={name}
        type="checkbox"
        checked={value === 'J'}
        onChange={e => onChange(e.target.checked ? 'J' : '')}
        data-supertokens={`conditionCheckbox ${hasError ? 'inputError' : ''}`}
      />
      <Typography.Text
        data-supertokens={`conditionText ${hasError ? 'inputError' : ''}`}
      >
        {t('AUTH_CONSENT_NOTICE_PREFIX')}
        <Link
          target="_blank"
          rel="noopener noreferrer"
          href="/privacy-policy"
          data-supertokens="link"
        >
          {t('AUTH_CONSENT_NOTICE_LINK_DATAPROTECTION')}
        </Link>{' '}
        {t('AUTH_CONSENT_NOTICE_MIDDLE')}
        <Link
          target="_blank"
          rel="noopener noreferrer"
          href="/terms-and-conditions"
          data-supertokens="link"
        >
          {t('AUTH_CONSENT_NOTICE_LINK_TERMS')}
        </Link>{' '}
        {t('AUTH_CONSENT_NOTICE_SUFFIX')}*
      </Typography.Text>
    </label>
  );
};
